// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1o3MP","title":"InfoRow_title__1IHmc"};